<div class="loading-overlay" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>

<div mat-dialog-title>
  <h3>Enviar SMS</h3>
  <h5>para {{ count }} destinatários (números válidos)</h5>
</div>

<mat-dialog-content>
  <div class="padding-main-container full-size" *ngIf="!isLoading">
    <div [formGroup]="formGroup" class="full-width flex-vertical">
      <cm-text-input-with-variables
        [styling]="false"
        [variables]="smsVariablesFlat"
        placeholder="Escreva aqui a mensagem a enviar"
        (change)="smsTextChanged($event)"
      ></cm-text-input-with-variables>

      <div class="message-preview">
        <mat-icon>visibility</mat-icon>
        <button mat-icon-button [disabled]="sampleIndex <= 0" (click)="decreaseSampleIndex()">
          <mat-icon class="p">chevron_left</mat-icon>
        </button>
        <button mat-icon-button [disabled]="sampleIndex >= count - 1" (click)="increaseSampleIndex()">
          <mat-icon class="p">chevron_right</mat-icon>
        </button>

        <span class="flex-1"
          >{{ sampleMessage }} <b>({{ sampleMessageLength }} caractéres)</b></span
        >
      </div>

      <mat-form-field appearance="outline">
        <mat-label>SMS Provider</mat-label>
        <mat-select [formControlName]="formAttributes.provider">
          <mat-option *ngFor="let provider of smsProviders" [value]="provider" [disabled]="!provider.enabled">
            {{ provider.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="selectedRelayType !== SmsRelayType.DEVICE">
        <mat-label>Agendar</mat-label>
        <cm-date-time-control [formControlName]="formAttributes.date"></cm-date-time-control>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" [disabled]="formGroup.invalid" (click)="send()">Enviar</button>
  <button mat-flat-button (click)="cancel()">Cancelar</button>
</mat-dialog-actions>
